import { cn } from '@/lib/utils'

export interface TocItem {
  id: string
  title: string
}

interface TableOfContentsProps {
  items: TocItem[]
  activeSection: string
  onItemClick: (id: string) => void
}

export const TableOfContents = ({
  items,
  activeSection,
  onItemClick,
}: TableOfContentsProps) => {
  return (
    <nav className="py-4 lg:py-0">
      <h2 className="text-[11px] font-semibold uppercase tracking-widest text-neutral-400 mb-5 pl-3">
        On this page
      </h2>
      <ul className="space-y-0.5">
        {items.map((item) => {
          const isActive = activeSection === item.id

          return (
            <li key={item.id} className="relative">
              <div
                className={cn(
                  'absolute left-0 top-1/2 -translate-y-1/2 w-[2px] rounded-full transition-all duration-300 ease-out',
                  isActive
                    ? 'h-5 bg-orange-primary opacity-100'
                    : 'h-0 bg-transparent opacity-0'
                )}
              />

              <button
                onClick={() => onItemClick(item.id)}
                className={cn(
                  'w-full text-left pl-3 pr-2 py-2 text-[13px] leading-snug',
                  'transition-colors duration-200',
                  'hover:text-neutral-900',
                  isActive
                    ? 'text-orange-primary font-medium'
                    : 'text-neutral-500'
                )}
              >
                {item.title}
              </button>
            </li>
          )
        })}
      </ul>
    </nav>
  )
}
